import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import PublicProfile from "./PublicProfile";
import { QrCode } from "lucide-react";

export default function VariantSharePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/v/${token}`)
      .then((res) => {
        if (res.data.suspended) { navigate("/suspended"); return; }
        setData(res.data);
      })
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!data || !data.profile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-center p-6">
        <div>
          <QrCode className="mx-auto text-muted-foreground mb-4" size={40} />
          <h1 className="text-xl font-bold mb-2">Link Not Found</h1>
          <p className="text-muted-foreground text-sm">This Smart-QR variant link does not exist.</p>
        </div>
      </div>
    );
  }

  return <PublicProfile prefetchedData={data} />;
}
